import { jsx as _jsx } from "react/jsx-runtime";
import MaskInput from "@mona-health/react-input-mask";
import styled from "styled-components";
const noop = () => { };
export const StyledInputWrapper = styled.div `
  position: relative;

  button {
    svg {
      width: 1.25rem;
    }
  }
`;
export const StyledMultiDateWrapper = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  div {
    margin-right: 1rem;
  }
`;
export const StyledMaskInput = styled((props) => _jsx(MaskInput, Object.assign({}, props, { onFocus: props.onFocus || noop }))) `
  font-family: "AktivGrotesk", helvetica, arial, sans-serif;
  height: 2.5rem;
  width: 100%;
  padding: 0 2.5rem 0 0.5rem;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid
    ${({ theme, selected, error }) => error
    ? theme.colors.error
    : selected
        ? theme.colors.black
        : theme.colors.grey10};
  border-radius: 0;
  color: ${({ theme, selected, value }) => (selected && value) || (!selected && value)
    ? theme.colors.black
    : `rgba(${theme.colors.transparentBlack}, 0.36);`};
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  outline: none;

  @media ${({ theme }) => theme.device.touch} {
    height: 2.75rem;
  }

  svg {
    fill: ${({ theme }) => theme.colors.black};
  }

  &:hover {
    background: ${({ theme }) => theme.colors.grey03};
    border: 1px solid ${({ theme }) => theme.colors.grey14};
  }

  &:active {
    background: ${({ theme }) => theme.colors.grey05};
    border: 1px solid ${({ theme }) => theme.colors.black};
  }

  &:focus {
    background: ${({ theme }) => theme.colors.white};

    ${({ focusVisible, theme }) => focusVisible ? `border: 1px solid ${theme.colors.primaryLight};` : ""}
    ${({ focusVisible, theme }) => focusVisible ? `outline: 1px solid ${theme.colors.primaryLight};` : ""}
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.grey03};
    border: 1px solid transparent;
    color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.26);
    svg {
      fill: 1px solid
        rgba(${({ theme }) => theme.colors.transparentBlack}, 0.26);
    }
  }

  .readonly {
    background: ${({ theme }) => theme.colors.grey04};
    border: 1px solid transparent;
    color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.36);
    svg {
      display: none;
    }
  }

  .error {
    background: ${({ theme }) => theme.colors.grey04};
    border: 1px solid ${({ theme }) => theme.colors.error};
    svg {
      display: none;
    }
  }
`;
export const StyledDateInputWithIcon = styled.div `
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  label {
    &:first-child {
      margin-bottom: 0.25rem;
      color: ${({ theme }) => theme.colors.grey13};
    }
  }

  .error-msg {
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colors.error};
  }

  button {
    cursor: pointer;
    position: absolute;
    right: 0;
    height: 2.5rem;
    display: flex;
    width: 2.5rem;
    justify-content: center;
  }
`;
